import { TbArrowUpRight } from "react-icons/tb";
import { Link } from "react-router";

interface MoreContentButtonProps {
  className?: string;
  label?: string;
}

export function MoreContentButton({
  className,
  label = "BACK TO GALLERY",
}: MoreContentButtonProps) {
  return (
    <Link
      to="/gallery"
      className={`bg-nav-light text-nav-dark hover:text-nav-dark active:bg-nav-dark active:text-nav-light inline-flex cursor-pointer items-center gap-1.5 rounded-sm px-5.5 py-3 text-sm font-semibold whitespace-nowrap shadow-[0_4px_12px_rgba(0,0,0,0.3)] transition-all duration-300 ease-out hover:bg-neutral-300 hover:shadow-[0_6px_16px_rgba(0,0,0,0.35)] active:shadow-[0_6px_16px_rgba(0,0,0,0.35)] ${className ?? ""}`}
    >
      <span>{label}</span>
      <TbArrowUpRight className="size-4.5" />
    </Link>
  );
}
